export default __webpack_public_path__ + "static/set-us-apart-3-9a47c8356a5d0f6b03c27d29e8ece611.jpg";